import { useUserEventLogger } from '@repo/tracking-service';
import { List } from '@zenterprise-inc/ui';

import FillRegisterCert from '@/assets/illust-icons/fill-register-cert.svg';

const CorporationJointCertificateList = ({ handleClick }: { handleClick: () => void }) => {
  const { sendClickEvent } = useUserEventLogger();
  return (
    <List.Basic
      left={<FillRegisterCert width={36} height={36} />}
      title={{ text: '공동인증서로 조회하기', titleStyle: 'headline-18' }}
      subText={{ text: '홈택스에 등록된 인증서로 조회해요.' }}
      listIcon
      onClick={() => {
        sendClickEvent(`corps-selectauth_commoncert`);
        handleClick();
      }}
      className="page-padding cursor-pointer"
    />
  );
};

export default CorporationJointCertificateList;
